var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useDOMRect } from '@anton.bobrov/react-hooks';
import { getAutoVerticalAlignment } from './getAutoVerticalAlignment';
import { getVerticalAlignmentStyles } from './getVerticalAlignmentStyles';
import { getAutoHorizontalAlignment } from './getAutoHorizontalAlignment';
import { getHorizontalAlignmentStyles } from './getHorizontalAlignmentStyles';
export function usePosition(_a) {
    var _b, _c;
    var positionRef = _a.positionRef, isDisabled = _a.isDisabled, verticalAlignmentProp = _a.verticalAlignment, horizontalAlignmentProp = _a.horizontalAlignment, _d = _a.gap, gap = _d === void 0 ? 0 : _d, _e = _a.viewportGap, viewportGap = _e === void 0 ? 0 : _e, viewportRef = _a.viewportRef;
    var domRect = useDOMRect({ ref: positionRef, isDisabled: isDisabled });
    var verticalAlignment = (!verticalAlignmentProp || verticalAlignmentProp === 'auto'
        ? getAutoVerticalAlignment(domRect)
        : verticalAlignmentProp) || 'down';
    var horizontalAlignment = (!horizontalAlignmentProp || horizontalAlignmentProp === 'auto'
        ? getAutoHorizontalAlignment(domRect)
        : horizontalAlignmentProp) || 'center';
    var verticalAlignmentStyles = verticalAlignment && domRect
        ? getVerticalAlignmentStyles({
            alignment: verticalAlignment,
            domRect: domRect,
            gap: gap,
        })
        : undefined;
    var horizontalAlignmentStyles = horizontalAlignment && domRect
        ? getHorizontalAlignmentStyles({
            alignment: horizontalAlignment,
            domRect: domRect,
            gap: gap,
            viewportGap: viewportGap,
            viewportRef: viewportRef,
        })
        : undefined;
    var transformY = (_b = verticalAlignmentStyles === null || verticalAlignmentStyles === void 0 ? void 0 : verticalAlignmentStyles.y) !== null && _b !== void 0 ? _b : 0;
    var transformX = (_c = horizontalAlignmentStyles === null || horizontalAlignmentStyles === void 0 ? void 0 : horizontalAlignmentStyles.x) !== null && _c !== void 0 ? _c : 0;
    return {
        verticalAlignment: verticalAlignment,
        horizontalAlignment: horizontalAlignment,
        style: __assign(__assign({ transform: "translate(".concat(transformX, ", ").concat(transformY, ")") }, (verticalAlignmentStyles && {
            top: verticalAlignmentStyles.top,
            bottom: verticalAlignmentStyles.bottom,
        })), (horizontalAlignmentStyles && {
            left: horizontalAlignmentStyles.left,
            right: horizontalAlignmentStyles.right,
            maxWidth: horizontalAlignmentStyles.maxWidth,
        })),
    };
}
//# sourceMappingURL=usePosition.js.map